import { ModelSetTransformer, ModelTransformer } from '../common/common.model';

export interface ExtMyPerformanceVsPeersItem {
    userVariance: number;
    sgVariance: number;
    nationalVariance: number;
    initial: string;
    imageFileName: string;
    metricPillarName: string;
}

export interface MyPerformanceVsPeersItem {
    userVariance: number;
    sgVariance: number;
    initial: string;
    metricPillarName: string;
}

export interface MyPerformanceVsPeers {
    d3: { options?: any; data: any };
}

class MyPerformanceVsPeersItemModelTransformer
    implements
        ModelTransformer<MyPerformanceVsPeersItem, ExtMyPerformanceVsPeersItem>
{
    transform(model: ExtMyPerformanceVsPeersItem): MyPerformanceVsPeersItem {
        return {
            userVariance: model.userVariance,
            sgVariance: model.sgVariance,
            initial: model.initial,
            metricPillarName: model.metricPillarName,
        };
    }
}

class MyPerformanceVsPeersItemModelSetTransformer extends ModelSetTransformer<
    MyPerformanceVsPeersItem,
    ExtMyPerformanceVsPeersItem
> {
    protected newTransformer(): ModelTransformer<
        MyPerformanceVsPeersItem,
        ExtMyPerformanceVsPeersItem
    > {
        return new MyPerformanceVsPeersItemModelTransformer();
    }
}

export class MyPerformanceVsPeersModelTransformer
    implements
        ModelTransformer<MyPerformanceVsPeers, ExtMyPerformanceVsPeersItem[]>
{
    transform(model: ExtMyPerformanceVsPeersItem[]): MyPerformanceVsPeers {
        const items =
            new MyPerformanceVsPeersItemModelSetTransformer().transform(model);
        const data = [
            {
                key: null,
                values: null,
            },
            {
                key: null,
                values: null,
            },
        ];
        data.forEach((value, index) => {
            value.values = items.map((item) => {
                return {
                    x: item.initial,
                    y: index === 0 ? item.userVariance : item.sgVariance,
                };
            });
        });
        return {
            d3: {
                data,
            },
        };
    }
}

export function validateMyPerformanceVsPeers(
    model: MyPerformanceVsPeers,
): void {
    const valid =
        model != null &&
        model.d3.data.find(
            (value) => value.values == null || value.values.length === 0,
        ) == null;
    if (!valid) {
        throw new Error('MyPerformanceVsPeers not valid');
    }
}
